module.exports = __webpack_public_path__ + "static/media/product-choice1.af77ca52.png";